<div class="grid h-dvh place-items-center">
  <div class="flex flex-col items-center gap-4 px-4 text-xl">
    <p>Dit apparaat is nog niet geactiveerd, hierdoor kan je nog geen spellen spelen.</p>

    <a
      class="cursor-pointer rounded bg-blue-500 px-4 py-2 font-bold text-white hover:bg-blue-700 disabled:opacity-50"
      role="button"
      routerLink="/activate"
    >
      Activeer nu
    </a>
  </div>
</div>
